// apps/cli/src/commands/enterprise/talents/index.ts
import type { Command } from 'commander';
import { registerEnterpriseTalentsList } from './list';
import { registerEnterpriseTalentsView } from './view';
import { registerEnterpriseTalentsRespond } from './respond';

export function registerEnterpriseTalentsCommand(parent: Command): void {
	// Scope note (issue #106 P1-4): applied pool only — visit tab not available yet (`--tab visit` → 400)
	// and no active candidate search over an API Key (`/api/search-talent` needs a JWT; see `wport doctor`).
	const talents = parent
		.command('talents')
		.description(
			'Browse & respond to your applied talent pool (visit tab n/a, no active candidate search — see `wport doctor`)'
		);
	registerEnterpriseTalentsList(talents);
	registerEnterpriseTalentsView(talents);
	registerEnterpriseTalentsRespond(talents);
}
